module.exports = __webpack_public_path__ + "static/media/1-3_Foiling_02.6adcdda6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/1-3_Foiling_02.jpg
// module id = 1716
// module chunks = 0